"use client";

import { useLayoutContext } from "@/context/layoutContext";

export function LayoutVisibilityWrapper({ children, hideIfCateringMode = true }: { children: React.ReactNode; hideIfCateringMode?: boolean }) {
  const { isFullscreenMode } = useLayoutContext();

  if (hideIfCateringMode && isFullscreenMode) {
    return null;
  }

  return <>{children}</>;
}
